<template>
  <div class="app">
    <v-app-bar clipped-left app dark dense color="bluePcm">
    <!-- <v-app-bar clipped-left app dark dense color="bluePcm" class="hidden-sm-and-down"> -->
      <ClientNameAppbar />
      <AppBarDefault />

      <!-- <v-tooltip bottom v-if="permissaoPabx">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="orangePcm" href="/pabx" target="_blank" v-bind="attrs" v-on="on" @click="goToPabx">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>PABX</span>
      </v-tooltip>

      <v-tooltip bottom v-if="permissaoRelatorioPabx">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="orangePcm"
            href="/relatorios-pabx"
            target="_blank"
            v-bind="attrs"
            v-on="on"
            @click="goToRelatoriosPabx"
          >
            <v-icon>mdi-clipboard-check-outline</v-icon>
          </v-btn>
        </template>
        <span>Relatórios PABX</span>
      </v-tooltip>

      <v-tooltip bottom v-if="permissaoCallCenter">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="orangePcm"
            href="/central-de-atendimento"
            target="_blank"
            v-bind="attrs"
            v-on="on"
            @click="goToCallCenter"
          >
            <v-icon>mdi-phone-message</v-icon>
          </v-btn>
        </template>
        <span>Central de Atendimento</span>
      </v-tooltip>

      <v-tooltip bottom v-if="permissaoPesquisaSatisfacao">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="orangePcm"
            href="/pesquisa-satisfacao"
            target="_blank"
            v-bind="attrs"
            v-on="on"
            @click="goToSatisfactionResearch"
          >
            <v-icon>mdi-text-box-search</v-icon>
          </v-btn>
        </template>
        <span>Pesquisa de Satisfação</span>
      </v-tooltip>

      <v-tooltip bottom v-if="numberOfPermissions > 1">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="orangePcm" href="/select" target="_blank" v-bind="attrs" v-on="on" @click="backToLobby">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>Selecionar Módulo</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="orangePcm" v-bind="attrs" v-on="on" @click="logoff">
            <v-icon>mdi-power-standby</v-icon>
          </v-btn>
        </template>
        <span>Deslogar</span>
      </v-tooltip>-->
    </v-app-bar> 
  </div>
</template>

<script>
import ClientNameAppbar from '@/componentes/ClientNameAppbar'
import AppBarDefault from '@/componentes/AppBar'
import { logoutMethod } from '@/utils/commomMethods/logoutMethod'
import { appBarMixins } from '@/mixins/appBarMixins'

export default {
  name: 'AppBar',
  components: { ClientNameAppbar, AppBarDefault },

  mixins: [appBarMixins],

  methods: {
    ...logoutMethod,
  },
}
</script>
<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
